const t = {
  name: "Reconciliation",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 3C16.9677 3 21 7.03228 21 12C21 14.1429 20.2515 16.1135 19 17.6592V14H17V21H24V19H20.4869C22.057 17.0987 23 14.6571 23 12C23 5.92772 18.0723 1 12 1V3Z" fill="currentColor"/>
<path d="M7 3H0V5H3.51315C1.94304 6.90134 1 9.3429 1 12C1 18.0723 5.92772 23 12 23V21C7.03228 21 3 16.9677 3 12C3 9.85709 3.74853 7.88647 5 6.34086V10H7V3Z" fill="currentColor"/>
<path d="M10.9999 15.4142L7.58569 12L8.99991 10.5858L10.9999 12.5858L14.9999 8.58578L16.4141 10L10.9999 15.4142Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Reconciliation
};
